import { render, staticRenderFns } from "./OriginalExam.vue?vue&type=template&id=1c6611ef&"
import script from "./OriginalExam.vue?vue&type=script&lang=js&"
export * from "./OriginalExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports